import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { environment } from '../../../environments';
import { Response } from '../../models';
import { ProcessorService } from './processor.service';

@Injectable()
export class TermsAndConditionsService {

  private policy: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public policy$: Observable<string> = this.policy.asObservable();

  constructor(private http: HttpClient, private processorService: ProcessorService) {
  }

  getPolicies() {
    return this.http.get(environment.apiBaseUrl + '/processor2-get-policy-processor')
      .pipe(
        shareReplay(1),
        tap(
          (policy: Response) => {
            this.policy.next(policy.data['body']);
          },
          err => {
            console.error(err);
          }
        )
      );
  }

  acceptAndUpdateProcessor() {
    const body = {
      acceptedPolicies: true
    };

    return this.processorService.updateProcessor(body);
  }
}
